import { ElementType, ReactElement } from 'react';

export interface ReactSelectItemInterface {
  value: string;
  label: string;
}

export enum SearchParameters {
  Services = 'sv',
  Store = 'lo',
  Packages = 'pck'
}

export type MenuItemType = {
  label: string;
  link: string;
};

export enum ShoppingCartName {
  Cart = 'Cart',
  Bag = 'Bag',
  Basket = 'Basket'
}

// Universal type for steps in any flow
export interface UniversalStep {
  step: number;
  title: string;
  icon?: ElementType | ReactElement;
  route?: string;
  mobileName?: string;
}

// Enum for different flow types
export enum ProgressIndicatorType {
  CART = 'cart',
  BOOKING = 'booking',
  GIFT_CARDS = 'giftCards'
}

// Configuration for each progress type
export interface ProgressIndicatorConfig {
  type: ProgressIndicatorType;
  showIcons: boolean;
  showNumbers: boolean;
  enableNavigation: boolean;
  useRouting: boolean;
  themePath: string;
  locationSection?: {
    show: boolean;
    locationName?: string;
    isSingleLocation?: boolean;
  };
}

export enum PromoErrorType {
  NO_ERROR,
  DOES_NOT_EXIST,
  DOES_NOT_QUALITY
}
